export const archivedTeamMessage = 'This team is archived and cannot be edited or unarchived.';
export const NO_TEAM = 'NO_TEAM';
export const NO_TEAM_LABEL = 'No assigned team';

export const SEEN_WELCOME_PAGE_STORAGE_KEY = 'seenWelcomePage';

export const SAVED_USER_ROLE = 'savedUserRole';
